<template>
  <div class="h-100 d-flex justify-center align-center">
    <v-card min-width="350">
      <v-card-title class="justify-center">
        <div class="text-center">
          <img width="80" :src="logo" alt="" />
          <div>เข้าสู่ระบบ | {{ appName }}</div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-tabs centered>
          <v-tab @click="setLoginMode('assessor')">ผู้ประเมิน</v-tab>
          <v-tab @click="setLoginMode('staff')">เจ้าหน้าที่</v-tab>
          <v-tab-item class="pt-6">
            <FormLogin />
          </v-tab-item>
          <v-tab-item class="pt-6">
            <FormLogin />
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { SET_LOGIN_MODE } from "@/store/action.type"
import FormLogin from "@/components/form/FormLogin"

export default {
  name: "Login",
  title: "เข้าสู่ระบบ",
  components: {
    FormLogin,
  },
  data() {
    return {
      logo: require("@/assets/logo.png"),
      appName: process.env.VUE_APP_NAME,
    }
  },
  mounted() {
    this.$store.dispatch(SET_LOGIN_MODE, "assessor")
  },
  methods: {
    setLoginMode(mode) {
      this.$store.dispatch(SET_LOGIN_MODE, mode)
    },
  },
}
</script>
